import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { useDeleteExperience } from "../../api/experience-actions/delete-experience";
import { isDialogOpen, setDialog } from "../../store/slices/global";

interface ConfirmExperimentDeleteDialogProps {
  currentExperience: ExperienceDto;
}
export const ConfirmExperienceDeleteDialog = ({
  currentExperience,
}: ConfirmExperimentDeleteDialogProps) => {
  const isOpen = useSelector(isDialogOpen("confirmExperimentDeletion"));

  const deleteExperience = useDeleteExperience(currentExperience, "experiment");

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setDialog({ dialog: "confirmExperimentDeletion", open: false }));
  };

  const onYesClick = () => {
    deleteExperience.mutate({
      body: { variationId: undefined },
      queryParams: undefined,
      pathParams: {
        experienceId: currentExperience.id!,
        action: "delete",
      },
    });
  };

  useEffect(() => {
    if (deleteExperience.isSuccess) {
      handleClose();
      deleteExperience.reset();
    }
  }, [deleteExperience]);

  return (
    <IgDialog
      title={currentExperience.name}
      subtitle={"Are you sure you want to delete this experiment?"}
      handleClose={handleClose}
      showDialog={isOpen}
      handleYesClick={onYesClick}
      yesButtonText={"Yes, I'm sure"}
      loading={deleteExperience.isPending}
      shouldNotClose={true}
      dialogHeight={"235px"}
    />
  );
};
